import React, { forwardRef } from "react";

const Input = forwardRef((props, ref) => {
  const { className, title, name, errors, ...rest } = props;

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {title && (
        <label htmlFor={name} className="text-sm text-wce-neutral-9">
          {title}
        </label>
      )}
      <input
        className={`border border-wce-neutral-5 px-3 py-2 rounded-xl`}
        ref={ref}
        name={name}
        {...rest}
      />
      {errors?.[name]?.message && (
        <span className="text-sm text-wce-pink-bright">
          {errors?.[name]?.message}
        </span>
      )}
    </div>
  );
});

export default Input;
